/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Controls_LabelInputs */



/**
* | output |
* | --- |
* | "Position controls" |
*
* @param {Position_Controls_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_controls_label = /** @type {((inputs?: Position_Controls_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Controls_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Controles de position")
	if (locale === "de") return /** @type {LocalizedString} */ ("Positionssteuerungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlli di posizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиционные элементы управления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Controles de posición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置控制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置コントロール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति नियंत्रण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controles de posição")
	return /** @type {LocalizedString} */ ("Position controls")
});